"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSwitcherSelector = exports.overrideUrl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const storm_ui_1 = require("@amzn/storm-ui");
const RegionSwitcherSelectorPopper_1 = __importDefault(require("../shared/RegionSwitcherSelectorPopper/RegionSwitcherSelectorPopper"));
const RegionSwitcherSelectorDropdown_1 = __importDefault(require("../shared/RegionSwitcherSelectorDropdown/RegionSwitcherSelectorDropdown"));
const RegionSwitcherSelectorTrigger_1 = __importDefault(require("../shared/RegionSwitcherSelectorTrigger/RegionSwitcherSelectorTrigger"));
const regionUtils_1 = require("../../utils/regionUtils");
const RegionRadioGroup_1 = __importDefault(require("../shared/RegionRadioGroup/RegionRadioGroup"));
const url_parse_1 = __importDefault(require("url-parse"));
const TranslationProvider_1 = require("../shared/TranslationProvider/TranslationProvider");
const overrideUrl = (account) => {
    const re = new RegExp(/\/dsp\/[A-Z0-9.]+/i);
    // Check if the current path contains /advertisers/ pattern
    const advertisersPattern = /\/dsp\/[A-Z0-9.]+\/advertisers\/[0-9]+/i;
    const currentLocationPathname = window.location.pathname;
    // If the current path contains /dsp/{id}/advertisers/{id}, don't override the URL, 
    if (advertisersPattern.test(currentLocationPathname)) {
        return;
    }
    if (account.url) {
        // have to add a dummy protocol that will be removed in line 64 so the URL parses properly
        let urlParse;
        if (account.url.startsWith('//')) {
            urlParse = new url_parse_1.default('http:' + account.url);
        }
        else if (!account.url.startsWith('http')) {
            urlParse = new url_parse_1.default('http://' + account.url);
        }
        else {
            urlParse = new url_parse_1.default(account.url);
        }
        if (urlParse.pathname !== '' &&
            urlParse.pathname !== currentLocationPathname &&
            re.test(urlParse.pathname) &&
            re.test(currentLocationPathname)) {
            const entityReplacementStr = re.exec(urlParse.pathname)[0];
            urlParse.set('pathname', currentLocationPathname.replace(re, entityReplacementStr));
            urlParse.set('protocol', '');
            account.url = '//' + urlParse.href;
        }
    }
};
exports.overrideUrl = overrideUrl;
const RegionSwitcherSelector = ({ id, currentAccount, accounts, language = 'en-US', onClose, onSelect, mode = 'popper', }) => {
    (0, exports.overrideUrl)(currentAccount);
    accounts.forEach((a) => (0, exports.overrideUrl)(a));
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [selectedRegion, setSelectedRegion] = (0, react_1.useState)(currentAccount);
    const [tempRegion, setTempRegion] = (0, react_1.useState)(currentAccount);
    const handleClose = (event) => {
        setTempRegion(selectedRegion);
        onClose?.(event);
        setIsOpen(false);
    };
    const handleSelect = (event) => {
        onSelect?.(tempRegion, event);
        setSelectedRegion(tempRegion);
        setIsOpen(false);
    };
    const handleClickTrigger = () => {
        setIsOpen(true);
    };
    const handleChange = (value) => {
        setTempRegion(value);
    };
    // New handler for dropdown region change to trigger the onSelect callback immediately. 
    const handleDropdownRegionChange = (account) => {
        setSelectedRegion(account);
        setTempRegion(account);
        onSelect?.(account);
    };
    if (currentAccount.entityId === undefined ||
        (Array.isArray(accounts) && accounts.length === 0)) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(storm_ui_1.ThemeProvider, { children: (0, jsx_runtime_1.jsx)(TranslationProvider_1.TranslationProvider, { locale: language, children: mode === 'dropdown' ? ((0, jsx_runtime_1.jsx)(RegionSwitcherSelectorDropdown_1.default, { id: id, accounts: accounts ? accounts.sort((a, b) => (0, regionUtils_1.regionOrdering)(a, b)) : [], selectedRegion: selectedRegion, onRegionChange: handleDropdownRegionChange })) : ((0, jsx_runtime_1.jsx)(RegionSwitcherSelectorPopper_1.default, { id: id, isOpen: isOpen, onClose: handleClose, onSelect: handleSelect, trigger: (0, jsx_runtime_1.jsx)(RegionSwitcherSelectorTrigger_1.default, { onClick: handleClickTrigger, currentRegionId: selectedRegion.regionId }), children: (0, jsx_runtime_1.jsx)(RegionRadioGroup_1.default, { id: id, onChange: handleChange, accounts: accounts ? accounts.sort((a, b) => (0, regionUtils_1.regionOrdering)(a, b)) : [], selected: tempRegion }) })) }) }));
};
exports.RegionSwitcherSelector = RegionSwitcherSelector;
exports.default = exports.RegionSwitcherSelector;
//# sourceMappingURL=RegionSwitcherSelector.js.map